'use client';

import type { QuoteBlock } from '@impact/types';

interface Props {
  block: QuoteBlock;
  editing?: boolean;
}

/**
 * Card variant: elevated card with accent stripe, distinct from the default card style
 */
export function QuoteCard({ block, editing }: Props) {
  const { text, author, role, imageUrl } = block.data;

  return (
    <div className="my-12 overflow-hidden rounded-2xl border border-border bg-background shadow-sm">
      <div className="h-1 bg-gradient-to-r from-primary to-primary/50" />
      <div className="p-8">
        <blockquote
          className="text-xl font-medium text-foreground leading-relaxed"
          {...(editing ? { 'data-editable': 'data.text' } : {})}
        >
          &ldquo;{text}&rdquo;
        </blockquote>
        {author || role ? (
          <div className="mt-6 flex items-center gap-4 pt-6 border-t border-border">
            {imageUrl ? (
              <div className="relative h-12 w-12 flex-shrink-0 rounded-full overflow-hidden">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  src={imageUrl}
                  alt={author ?? 'Quote author'}
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </div>
            ) : (
              <div className="h-12 w-12 flex-shrink-0 rounded-full bg-primary/10 flex items-center justify-center">
                <span className="text-lg font-bold text-primary">
                  {author ? author[0]?.toUpperCase() : '"'}
                </span>
              </div>
            )}
            <div>
              {author ? (
                <div
                  className="font-semibold text-foreground text-sm"
                  {...(editing ? { 'data-editable': 'data.author' } : {})}
                >
                  {author}
                </div>
              ) : null}
              {role ? (
                <div
                  className="text-xs text-muted-foreground mt-0.5"
                  {...(editing ? { 'data-editable': 'data.role' } : {})}
                >
                  {role}
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
